// Filter items based on the selected filter state
export const filterItems = (items, filterState) => {
  if (filterState === 'all') return items;
  if (filterState === 'active') return items.filter(item => !item.completed);
  if (filterState === 'completed') return items.filter(item => item.completed);
  return items;
};

// Get background color based on priority and selection state
export const getPriorityColor = (priority, isSelected = false) => {
  if (!priority) {
    return isSelected ? 'bg-gray-200' : '';
  }
  
  switch (priority) {
    case 'high':
      return isSelected ? 'bg-yellow-200' : 'bg-yellow-100';
    case 'medium':
      return isSelected ? 'bg-orange-200' : 'bg-orange-100';
    case 'low':
      return isSelected ? 'bg-blue-200' : 'bg-blue-100';
    default:
      return isSelected ? 'bg-gray-200' : '';
  }
};

// Get task with initiatives
export const getTaskWithInitiatives = (goals, goalId, stepId, taskId) => {
  const goal = goals.find(g => g.id === goalId);
  if (!goal) return null;
  
  const step = goal.steps.find(s => s.id === stepId);
  if (!step) return null;
  
  const task = step.tasks.find(t => t.id === taskId);
  if (!task) return null;
  
  // Ensure initiatives is always an array
  if (!task.initiatives) {
    return {...task, initiatives: []};
  }
  
  return task;
};

// Get initiatives count
export const getInitiativesCount = (task) => {
  return task && task.initiatives ? task.initiatives.length : 0;
}; 